var map = {
	"./apple.svg": "1926",
	"./email.svg": "a092",
	"./facebook.svg": "2b2f",
	"./google.svg": "b29f",
	"./ps.svg": "8320",
	"./steam.svg": "17e9",
	"./twitch.svg": "979d",
	"./twitter.svg": "2652",
	"./xbox.svg": "8f54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3281";